import React from 'react';
import { useCollection } from '../data/firestore';
import { useAuth, signOut } from '../AuthContext';
import { MarkdownLite } from './Plan';

// Platform documentation, served from the Firestore `docsSections` collection
// (allowlist-gated in the rules — this page is just the viewer, same pattern
// as the business plan). Content is written via admin tooling.
export default function Docs() {
  const { user } = useAuth();
  const { docs: sections, error } = useCollection('docsSections', {
    orderBy: 'order',
    dir: 'asc',
  });

  if (error) {
    const denied = /permission/i.test(error);
    return (
      <div className="cs-page">
        <div className="cs-empty" style={{ maxWidth: 520 }}>
          {denied ? (
            <>
              <p style={{ marginTop: 0 }}>
                <strong>{user?.email}</strong> isn't approved for the platform
                docs. Access is invite-only — contact Nventr to have your email
                added.
              </p>
              <button className="cs-btn cs-btn-outline cs-btn-sm" onClick={() => signOut()}>
                Sign out
              </button>
            </>
          ) : (
            <>Couldn't load the docs: {error}</>
          )}
        </div>
      </div>
    );
  }
  if (sections === null) {
    return (
      <div className="cs-page">
        <div className="cs-empty">Loading the docs…</div>
      </div>
    );
  }

  return (
    <div className="cs-page cs-plan">
      <h1>nventr Platform — Technical Documentation</h1>
      <p className="cs-store-note">
        The platform book and its companion volume, License &amp; Deployment
        Protocols — synced from the same masters as the printed editions
        (overview → features → details) · Confidential · September 2026.
      </p>

      <nav className="cs-plan-toc">
        {sections.map((s) => (
          <a key={s.id} href={`#${s.id}`}>{s.title}</a>
        ))}
      </nav>

      {sections.map((s) => (
        <section key={s.id} id={s.id} className="cs-plan-section">
          <h2>{s.title}</h2>
          <MarkdownLite text={s.body} />
        </section>
      ))}
    </div>
  );
}
